/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Tab_ChecklistInputs */

const en_task_flow_tab_checklist = /** @type {(inputs: Task_Flow_Tab_ChecklistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checklist`)
};

const pt_br2_task_flow_tab_checklist = /** @type {(inputs: Task_Flow_Tab_ChecklistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checklist`)
};

/**
* | output |
* | --- |
* | "Checklist" |
*
* @param {Task_Flow_Tab_ChecklistInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_tab_checklist = /** @type {((inputs?: Task_Flow_Tab_ChecklistInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Tab_ChecklistInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_tab_checklist(inputs)
	return pt_br2_task_flow_tab_checklist(inputs)
});